import { setFilters, submitFilters } from '../store/pagedata'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useRef, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Spinner from './Spinner'
import Typeahead from './Typeahead'
import classNames from 'classnames'
import { initialFilters } from '../store/pagedata'
import queryString from 'query-string'
import styles from '../styles/FilterPanel.module.scss'
import { useLocation } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { v4 } from 'uuid'

const FilterPanel = () => {
  const dispatch = useDispatch()
  const { dir } = useParams()
  const savedCallback = useRef()
  const filterError = useSelector((state) => state.pagedata.filterError)
  const filters = useSelector((state) => state.pagedata.filters)
  const isLoading = useSelector((state) => state.pagedata.isLoading)
  const query = useSelector((state) => state.pagedata.query)
  const { search } = useLocation()
  const [showTimeAlert, setShowTimeAlert] = useState(false)

  const initCountRow = { key: v4(), number: '', op: 'gt', type: 'c' }
  const initNameRow = { key: v4(), name: [], preposition: 'in' }
  const [countFilterForm, setCountFilterForm] = useState(initCountRow)
  const [nameFilterForm, setNameFilterForm] = useState(initNameRow)

  const isLoadingFilters = isLoading && filters !== initialFilters

  useEffect(() => {
    if (!query?.f && search) {
      const { f } = queryString.parse(search)
      const countRows =
        f &&
        f
          .split(';')
          .map((str) => {
            const splitStr = str.split('=')
            const splitKey = splitStr[0].split(':')
            return splitStr.length === 2 && splitKey.length === 2
              ? {
                  key: v4(),
                  number: splitStr[1],
                  op: splitKey[1],
                  type: splitKey[0].split(''),
                }
              : {}
          })
          .filter(
            (row) =>
              ['gt', 'lt', 'eq', 'ne'].includes(row.op) &&
              row.type.length > 0 &&
              row.number
          )
      const nameRows =
        f &&
        f
          .split(';')
          .map((str) => {
            const splitStr = str.split('=')
            return splitStr.length === 2
              ? { key: v4(), name: [splitStr[1]], preposition: splitStr[0] }
              : {}
          })
          .filter((row) => ['in', 'out'].includes(row.preposition) && row.name)
      if (
        countRows &&
        countRows.length > 0 &&
        nameRows &&
        nameRows.length > 0
      ) {
        dispatch(setFilters({ ...filters, count: countRows, name: nameRows }))
      } else if (countRows && countRows.length > 0) {
        dispatch(setFilters({ ...filters, count: countRows }))
      } else if (nameRows && nameRows.length > 0) {
        dispatch(setFilters({ ...filters, name: nameRows }))
      }
    }
  }, [])

  useEffect(() => {
    if (isLoadingFilters) {
      savedCallback.current = setInterval(() => setShowTimeAlert(true), 20000)

      return () => {
        clearInterval(savedCallback.current)
      }
    } else {
      clearInterval(savedCallback.current)
      setShowTimeAlert(false)
    }
  }, [isLoadingFilters])

  return (
    <>
      <h5 className='title'>Advanced Filters</h5>
      <Card className='shadow-sm'>
        <Card.Body className={styles.body}>
          <div className={styles.container}>
            <div className={styles.row}>
              <select
                className={classNames('form-control', styles.filtersType)}
                onChange={(e) =>
                  setNameFilterForm({
                    ...nameFilterForm,
                    preposition: e.target.value,
                  })
                }
                value={nameFilterForm.preposition}
              >
                <option value='in'>With</option>
                <option value='out'>Without</option>
              </select>
              <Typeahead
                className={styles.filtersName}
                clearButton
                icon={null}
                onChange={(value) =>
                  setNameFilterForm({ ...nameFilterForm, name: value })
                }
                placeholder='Card name'
                selected={nameFilterForm.name}
              />
              <button
                className='btn btn-primary'
                disabled={nameFilterForm.name.length === 0}
                onClick={() => {
                  dispatch(
                    setFilters({
                      ...filters,
                      name: [...filters.name, nameFilterForm],
                    })
                  )
                  setNameFilterForm({ ...nameFilterForm, name: [] })
                }}
              >
                +
              </button>
            </div>
            <div className={styles.row}>
              <select
                className={classNames('form-control', styles.filtersType)}
                onChange={(e) =>
                  setCountFilterForm({
                    ...countFilterForm,
                    type: e.target.value,
                  })
                }
                value={countFilterForm.type}
              >
                <option value='c'>Creatures</option>
                <option value='i'>Instants</option>
                <option value='s'>Sorceries</option>
                <option value='a'>Artifacts</option>
                <option value='e'>Enchantments</option>
                <option value='p'>Planeswalkers</option>
                <option value='l'>Lands</option>
                <option value='d'>Price</option>
              </select>
              <select
                className={classNames('form-control', styles.filtersOp)}
                onChange={(e) =>
                  setCountFilterForm({ ...countFilterForm, op: e.target.value })
                }
                value={countFilterForm.op}
              >
                <option value='gt'>&gt;</option>
                <option value='lt'>&lt;</option>
                <option value='eq'>=</option>
                <option value='ne'>&ne;</option>
              </select>
              <input
                className={classNames('form-control', styles.filtersNum)}
                placeholder='Number'
                onChange={(e) =>
                  setCountFilterForm({
                    ...countFilterForm,
                    number: e.target.value,
                  })
                }
                type='number'
                value={countFilterForm.number}
              />
              <button
                className='btn btn-primary'
                disabled={countFilterForm.number.length === 0}
                onClick={() => {
                  dispatch(
                    setFilters({
                      ...filters,
                      count: [...filters.count, countFilterForm],
                    })
                  )
                  setCountFilterForm({ ...countFilterForm, number: '' })
                }}
              >
                +
              </button>
            </div>
            <div className={styles.filterAlerts}>
              {filters.name.map((filter, i) => (
                <Alert
                  className={styles.filterAlert}
                  key={filter.key}
                  variant='info'
                >
                  <span>{`${
                    { in: 'With', out: 'Without' }[filter.preposition]
                  } ${filter.name}`}</span>
                  <FontAwesomeIcon
                    className={styles.delIcon}
                    icon='times'
                    onClick={() =>
                      dispatch(
                        setFilters({
                          ...filters,
                          name: [
                            ...filters.name.slice(0, i),
                            ...filters.name.slice(i + 1),
                          ],
                        })
                      )
                    }
                  />
                </Alert>
              ))}
              {filters.count.map((filter, i) => (
                <Alert
                  className={styles.filterAlert}
                  key={filter.key}
                  variant='info'
                >
                  <span>{`${
                    {
                      eq: 'Exactly',
                      gt: 'More than',
                      lt: 'Less than',
                      ne: 'Exactly not',
                    }[filter.op]
                  } ${{
                    a: () =>
                      `${filter.number} artifact${
                        filter.number !== 1 ? 's' : ''
                      }`,
                    c: () =>
                      `${filter.number} creature${
                        filter.number !== 1 ? 's' : ''
                      }`,
                    d: () => `$${filter.number}`,
                    e: () =>
                      `${filter.number} enchantment${
                        filter.number !== 1 ? 's' : ''
                      }`,
                    i: () =>
                      `${filter.number} instant${
                        filter.number !== 1 ? 's' : ''
                      }`,
                    l: () =>
                      `${filter.number} land${filter.number !== 1 ? 's' : ''}`,
                    p: () =>
                      `${filter.number} planeswalker${
                        filter.number !== 1 ? 's' : ''
                      }`,
                    s: () =>
                      `${filter.number} sorcer${
                        filter.number !== 1 ? 'ies' : 'y'
                      }`,
                  }[filter.type]()}`}</span>
                  <FontAwesomeIcon
                    className={styles.delIcon}
                    icon='times'
                    onClick={() =>
                      dispatch(
                        setFilters({
                          ...filters,
                          count: [
                            ...filters.count.slice(0, i),
                            ...filters.count.slice(i + 1),
                          ],
                        })
                      )
                    }
                  />
                </Alert>
              ))}
              <Button
                className={styles.submit}
                disabled={
                  (filters.name.length === 0 && filters.count.length === 0) ||
                  isLoadingFilters
                }
                onClick={() => dispatch(submitFilters(dir))}
                type='primary'
              >
                {isLoadingFilters ? <Spinner /> : 'Filter'}
              </Button>
              <div className={styles.pad}>&nbsp;</div>
              {showTimeAlert && !filterError && (
                <Alert className={styles.timeWarning} variant='warning'>
                  Filters on large datasets may take 30+ seconds to complete.
                </Alert>
              )}
              {filterError && (
                <Alert className={styles.timeWarning} variant='danger'>
                  {filterError}
                </Alert>
              )}
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  )
}

export default FilterPanel
